import {baseURL} from '@/infrastructure/Configuration'
import SessionApi from "@/mixins/Services/SessionApi";
import Utils from "@/mixins/Utils";

const COMPANY = 'company/';
const OFFICE = '/office';

export default {
    mixins: [SessionApi, Utils],
    methods: {
        async getOffices() {
            const url = `${baseURL}${COMPANY}${this.loadCompanyId()}${OFFICE}`
            const response = await this.httpSession().get(url)
            console.debug('[OFFICES][getOffices] RESPONSE', response.data)
            return response.data;
        },

        async createOffice(data) {
            console.debug('[OFFICES][createOffice] request data', data)
            const url = `${baseURL}${COMPANY}${this.loadCompanyId()}${OFFICE}`
            const response = await this.httpSession().post(url, {...data})
            console.debug('[OFFICES][createOffice] RESPONSE', response.data)
            return response.data
        },

        async updateOffice(data) {
            console.debug('[OFFICES][updateOffice] request data', data)
            const url = `${baseURL}${COMPANY}${this.loadCompanyId()}${OFFICE}`
            const response = await this.httpSession().put(url, {...data})
            console.debug('[OFFICES][updateOffice] RESPONSE', response.data)
            return response.data
        },

        async deleteOffice(officeId) {
            console.debug('[OFFICES][deleteOffice] request OfficeId', officeId)
            const url = `${baseURL}${COMPANY}${this.loadCompanyId()}${OFFICE}/${officeId}`
            const response = await this.httpSession().delete(url)
            console.debug('[OFFICES][deleteOffice] RESPONSE', response.data)
            return response.data
        }
    }
};
